import { jsx, jsxs } from "react/jsx-runtime";
import React from "react";
import { Icon, Button, Intent, Classes, Callout } from "@blueprintjs/core";
import {
  FileUploadField,
  TextareaField,
  EditableTextField,
  CheckboxField,
  wrapDialog
} from "@teselagen/ui";
import { reduxForm, FieldArray } from "redux-form";
import { anyToJson } from "@teselagen/bio-parsers";
import { flatMap } from "lodash-es";
import uniqid from "shortid";
import { cloneDeep } from "lodash-es";
import classNames from "classnames";
import ToolbarItem from "./ToolbarItem";
import { connectToEditor } from "../withEditorProps";
import withEditorProps from "../withEditorProps";
import { showDialog } from "../GlobalDialogUtils";
import { compose } from "recompose";
import { array_move } from "./array_move";
export default connectToEditor(({ readOnly, toolBar = {} }) => {
  return {
    readOnly,
    isOpen: toolBar.openItem === "alignmentTool"
  };
})(({ toolbarItemProps, isOpen }) => {
  return /* @__PURE__ */ jsx(
    ToolbarItem,
    {
      ...{
        Icon: /* @__PURE__ */ jsx(Icon, { "data-test": "alignmentTool", icon: "align-left" }),
        // toggled: alignmentTool.isOpen,
        renderIconAbove: isOpen,
        // onIconClick: toggleFindTool,
        Dropdown: ConnectedAlignmentToolDropdown,
        onIconClick: "toggleDropdown",
        noDropdownIcon: true,
        tooltip: isOpen ? "Hide Alignment Tool" : "Align to This Sequence",
        ...toolbarItemProps
      }
    }
  );
});
class AlignmentToolDropdown extends React.Component {
  render() {
    const {
      savedAlignments = [],
      hasSavedAlignments,
      toggleDropdown,
      sequenceData
    } = this.props;
    return /* @__PURE__ */ jsxs("div", { children: [
      /* @__PURE__ */ jsx(
        Button,
        {
          intent: Intent.PRIMARY,
          onClick: () => {
            toggleDropdown();
            showDialog({
              dialogType: "AlignmentToolDialog",
              props: {
                createNewAlignment: this.props.createNewAlignment,
                upsertAlignmentRun: this.props.upsertAlignmentRun,
                initialValues: {
                  addedSequences: [{ ...sequenceData, isTemplate: true }]
                }
              }
            });
          },
          children: "Create New Alignment"
        }
      ),
      /* @__PURE__ */ jsx("br", {}),
      /* @__PURE__ */ jsx("br", {}),
      /* @__PURE__ */ jsx(Callout, { intent: "warning", children: "Note: This tool requires an alignment server to be hooked up for it to work properly. It will NOT work in the OVE demo page." }),
      /* @__PURE__ */ jsx("div", { className: "vespacer" }),
      hasSavedAlignments && /* @__PURE__ */ jsxs("div", { children: [
        /* @__PURE__ */ jsx("h6", { children: "Saved Alignments:" }),
        !savedAlignments.length && /* @__PURE__ */ jsx("div", { style: { fontStyle: "italic" }, children: " No Alignments" }),
        savedAlignments.map((savedAlignment, i) => {
          return /* @__PURE__ */ jsxs("div", { children: [
            "Saved Alignment ",
            i
          ] }, i);
        })
      ] })
    ] });
  }
}
const ConnectedAlignmentToolDropdown = withEditorProps(AlignmentToolDropdown);
class AlignmentTool extends React.Component {
  state = {
    templateSeqIndex: 0
  };
  sendSelectedDataToBackendForAlignment = async (values) => {
    const {
      addedSequences,
      isPairwiseAlignment,
      isAlignToRefSeq,
      isAutotrimmedSeq
    } = values;
    const {
      hideModal,
      /* onAlignmentSuccess, */
      createNewAlignment,
      // createNewMismatchesList,
      upsertAlignmentRun
    } = this.props;
    const { templateSeqIndex } = this.state;
    const addedSequencesToUse = array_move(addedSequences, templateSeqIndex, 0);
    let addedSequencesToUseTrimmed;
    if (isAutotrimmedSeq) {
      addedSequencesToUseTrimmed = cloneDeep(addedSequencesToUse);
      for (let i = 0; i < addedSequencesToUseTrimmed.length; i++) {
        if ("chromatogramData" in addedSequencesToUseTrimmed[i]) {
          if ("qualNums" in addedSequencesToUseTrimmed[i].chromatogramData) {
            const { suggestedTrimStart, suggestedTrimEnd } = mottTrim(
              addedSequencesToUseTrimmed[i].chromatogramData.qualNums
            );
            addedSequencesToUseTrimmed[i].sequence = addedSequencesToUseTrimmed[i].sequence.slice(suggestedTrimStart, suggestedTrimEnd + 1);
            const elementsToTrim = ["baseCalls", "basePos", "qualNums"];
            for (const element in addedSequencesToUseTrimmed[i].chromatogramData) {
              if (elementsToTrim.indexOf(element) !== -1) {
                addedSequencesToUseTrimmed[i].chromatogramData[element] = addedSequencesToUseTrimmed[i].chromatogramData[element].slice(
                  suggestedTrimStart,
                  suggestedTrimEnd + 1
                );
              }
            }
          }
        }
      }
    }
    let seqsToAlign;
    if (addedSequencesToUseTrimmed) {
      seqsToAlign = addedSequencesToUseTrimmed;
    } else {
      seqsToAlign = addedSequencesToUse;
    }
    hideModal();
    const alignmentId = uniqid();
    createNewAlignment({
      id: alignmentId,
      name: seqsToAlign[0].name + " Alignment"
    });
    upsertAlignmentRun({
      id: alignmentId,
      loading: true
    });
    window.toastr.success("Alignment submitted.");
    const replaceProtocol = (url) => {
      return url.replace("http://", window.location.protocol + "//");
    };
    const seqInfoToSend = seqsToAlign.map(({ sequence, name, id }) => {
      return {
        sequence,
        name,
        id
      };
    });
    const {
      alignedSequences: _alignedSequences,
      pairwiseAlignments,
      alignmentsToRefSeq
    } = await (await fetch({
      url: replaceProtocol("http://j5server.teselagen.com/alignment/run"),
      method: "post",
      body: JSON.stringify({
        //only send over the bear necessities :)
        sequencesToAlign: seqInfoToSend,
        isPairwiseAlignment,
        isAlignToRefSeq
      })
    })).json();
    let alignedSequences = _alignedSequences;
    if (alignmentsToRefSeq) {
      alignedSequences = alignmentsToRefSeq;
    }
    if (!alignedSequences && !pairwiseAlignments)
      window.toastr.error("Error running sequence alignment!");
    upsertAlignmentRun({
      id: alignmentId,
      pairwiseAlignments: pairwiseAlignments && pairwiseAlignments.map((alignedSequences2, topIndex) => {
        return alignedSequences2.map((alignmentData, innerIndex) => {
          return {
            sequenceData: seqsToAlign[innerIndex > 0 ? topIndex + 1 : 0],
            alignmentData,
            chromatogramData: seqsToAlign[innerIndex].chromatogramData
          };
        });
      }),
      alignmentTracks: alignedSequences && alignedSequences.map((alignmentData) => {
        return {
          sequenceData: seqsToAlign[alignmentData.name.slice(0, alignmentData.name.indexOf("_"))],
          alignmentData,
          chromatogramData: seqsToAlign[alignmentData.name.slice(0, alignmentData.name.indexOf("_"))].chromatogramData
        };
      })
      // alignmentTracks:
      //   alignedSequences &&
      //   alignedSequences.map((alignmentData, i) => {
      //     return {
      //       sequenceData: addedSequencesToUse[i],
      //       alignmentData,
      //       chromatogramData: addedSequencesToUse[i].chromatogramData
      //     };
      //   })
    });
  };
  handleFileUpload = (files, onChange) => {
    const { array } = this.props;
    flatMap(files, async (file) => {
      const results = await anyToJson(file.originalFileObj, {
        fileName: file.name,
        acceptParts: true
      });
      return results.forEach((result) => {
        if (result.success) {
          array.push("addedSequences", result.parsedSequence);
        } else {
          return window.toastr.warning("Error parsing file: ", file.name);
        }
      });
    });
    onChange([]);
  };
  renderAddSequence = ({ fields, templateSeqIndex }) => {
    const { handleSubmit } = this.props;
    const sequencesToAlign = fields.getAll() || [];
    return /* @__PURE__ */ jsxs("div", { children: [
      /* @__PURE__ */ jsx("h6", { children: "Or enter sequences in plain text format" }),
      /* @__PURE__ */ jsxs("div", { children: [
        /* @__PURE__ */ jsx(
          AddYourOwnSeqForm,
          {
            addSeq: (newSeq) => {
              fields.push(newSeq);
            }
          }
        ),
        /* @__PURE__ */ jsx("h6", { style: { marginTop: 15 }, children: "Sequences To Align: " }),
        !fields.getAll() && /* @__PURE__ */ jsx("div", { children: "No sequences added yet." }),
        /* @__PURE__ */ jsx(
          "div",
          {
            style: { maxHeight: 180, overflowY: "auto" },
            className: "veAlignmentToolSelectedSequenceList",
            children: sequencesToAlign.map((addedSeq, index) => {
              return /* @__PURE__ */ jsxs(
                "div",
                {
                  onClick: () => {
                    this.setState({
                      templateSeqIndex: index
                    });
                  },
                  style: {
                    borderBottom: "1px solid lightgrey",
                    paddingBottom: 4,
                    marginBottom: 4,
                    width: "100%",
                    justifyContent: "space-between",
                    alignItems: "center",
                    display: "flex"
                  },
                  children: [
                    /* @__PURE__ */ jsxs("div", { children: [
                      addedSeq.name,
                      " ",
                      /* @__PURE__ */ jsxs("span", { style: { fontSize: 10 }, children: [
                        " ",
                        "(",
                        addedSeq.sequence.length,
                        " bps)"
                      ] })
                    ] }),
                    index === templateSeqIndex && /* @__PURE__ */ jsx(
                      "div",
                      {
                        className: classNames(
                          Classes.TAG,
                          Classes.ROUND,
                          Classes.INTENT_PRIMARY
                        ),
                        children: "template"
                      }
                    ),
                    /* @__PURE__ */ jsx(
                      Button,
                      {
                        onClick: (e) => {
                          e.stopPropagation();
                          e.preventDefault();
                          fields.remove(index);
                          if (index === templateSeqIndex) {
                            this.setState({ templateSeqIndex: 0 });
                          }
                        },
                        children: "Remove"
                      }
                    )
                  ]
                },
                index
              );
            })
          }
        ),
        /* @__PURE__ */ jsx("br", {}),
        /* @__PURE__ */ jsx(
          CheckboxField,
          {
            name: "isPairwiseAlignment",
            style: { display: "flex", alignItems: "center" },
            label: /* @__PURE__ */ jsxs("div", { children: [
              "Create Pairwise Alignment",
              " ",
              /* @__PURE__ */ jsx("span", { style: { fontSize: 11 }, children: "Individually align each uploaded file against the template sequence (instead of creating a single Multiple Sequence Alignment)" })
            ] })
          }
        ),
        /* @__PURE__ */ jsx(
          CheckboxField,
          {
            name: "isAlignToRefSeq",
            style: { display: "flex", alignItems: "center" },
            label: /* @__PURE__ */ jsxs("div", { children: [
              "Align Sequencing Reads to Reference Sequence",
              " ",
              /* @__PURE__ */ jsx("span", { style: { fontSize: 11 }, children: "Align short sequencing reads to a long reference sequence" })
            ] })
          }
        ),
        /* @__PURE__ */ jsx(
          CheckboxField,
          {
            name: "isAutotrimmedSeq",
            style: { display: "flex", alignItems: "center" },
            label: /* @__PURE__ */ jsxs("div", { children: [
              "Auto-Trim Sequences",
              " ",
              /* @__PURE__ */ jsx("span", { style: { fontSize: 11 }, children: "Automatically trim low-quality ends of sequences based on quality scores" })
            ] })
          }
        ),
        /* @__PURE__ */ jsx(
          Button,
          {
            style: { marginTop: 15, float: "right" },
            intent: Intent.PRIMARY,
            disabled: sequencesToAlign.length < 2,
            onClick: handleSubmit(this.sendSelectedDataToBackendForAlignment),
            children: "Create alignment"
          }
        )
      ] })
    ] });
  };
  render() {
    const { selectFromSequenceLibraryHook } = this.props;
    const { templateSeqIndex } = this.state;
    return /* @__PURE__ */ jsxs("div", { style: { padding: 20 }, className: "veAlignmentTool", children: [
      /* @__PURE__ */ jsx("h6", { children: "Upload files you'd like to align (.ab1, .fasta, .gb) " }),
      /* @__PURE__ */ jsx(
        FileUploadField,
        {
          name: "alignmentToolSequenceUpload",
          style: { maxWidth: 400 },
          beforeUpload: this.handleFileUpload
        }
      ),
      selectFromSequenceLibraryHook && /* @__PURE__ */ jsx("h6", { children: "Or Select from your sequence library " }),
      /* @__PURE__ */ jsx(
        FieldArray,
        {
          name: "addedSequences",
          templateSeqIndex,
          component: this.renderAddSequence
        }
      )
    ] });
  }
}
export const AlignmentToolDialog = compose(
  wrapDialog({ title: "Create New Alignment" }),
  reduxForm({
    form: "veAlignmentTool"
  })
)(AlignmentTool);
const AddYourOwnSeqForm = reduxForm({
  form: "AddYourOwnSeqForm",
  validate: ({ name, sequence }) => {
    const errors = {};
    if (!name) {
      errors.name = "Required";
    }
    if (!sequence) {
      errors.sequence = "Required";
    }
    return errors;
  }
})(({ pristine, error, handleSubmit, reset, addSeq }) => {
  return /* @__PURE__ */ jsxs(
    "form",
    {
      onSubmit: handleSubmit((vals) => {
        reset();
        addSeq(vals);
      }),
      children: [
        /* @__PURE__ */ jsx(
          EditableTextField,
          {
            style: { maxWidth: 200 },
            placeholder: "Untitled Sequence",
            name: "name"
          }
        ),
        /* @__PURE__ */ jsx(
          TextareaField,
          {
            style: { maxWidth: 400 },
            placeholder: "AGTTGAGC",
            name: "sequence"
          }
        ),
        /* @__PURE__ */ jsx(Button, { disabled: pristine || error, type: "submit", children: "Add" })
      ]
    }
  );
});
function mottTrim(qualNums) {
  if (!qualNums) return;
  let startPos = 0;
  let endPos = 0;
  const totalScoreInfo = [];
  let score = 0;
  let totalScore = 0;
  const cutoff = 0.05;
  for (let i = 0; i < qualNums.length; i++) {
    score = cutoff - Math.pow(10, qualNums[i] / -10);
    totalScore += score;
    totalScoreInfo.push(totalScore);
    if (totalScore < 0) {
      totalScore = 0;
    }
  }
  const firstPositiveValue = totalScoreInfo.find((e) => {
    return e > 0;
  });
  startPos = totalScoreInfo.indexOf(firstPositiveValue);
  const highestValue = Math.max(...totalScoreInfo);
  endPos = totalScoreInfo.lastIndexOf(highestValue);
  return {
    suggestedTrimStart: startPos,
    suggestedTrimEnd: endPos
  };
}
